import React from 'react';
import { useFormikContext } from 'formik';
import Control from '../Control';
import text from '../../../text';
var AssignedPaymentForm = function() {
    var _useFormikContext = useFormikContext(), assignedPayment = _useFormikContext.values, touched = _useFormikContext.touched, errors = _useFormikContext.errors, handleBlur = _useFormikContext.handleBlur, handleChange = _useFormikContext.handleChange;
    return /*#__PURE__*/ React.createElement("div", {
        className: "AssignedPaymentForm w-100 mt-3"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", null, text('assignedPaymentMessage')), /*#__PURE__*/ React.createElement(Control, {
        as: "input",
        type: "text",
        name: "payerName",
        isFailed: touched.payerName && !!errors.payerName,
        value: assignedPayment.payerName,
        onChange: handleChange,
        onBlur: handleBlur,
        placeholder: text('enterName'),
        label: text('payerName'),
        validationError: touched.payerName && errors.payerName
    }), /*#__PURE__*/ React.createElement(Control, {
        as: "input",
        onBlur: handleBlur,
        onChange: handleChange,
        name: "payerEmail",
        label: text('payerEmail'),
        placeholder: text('enterEmail'),
        value: assignedPayment.payerEmail,
        isFailed: touched.payerEmail && !!errors.payerEmail,
        validationError: errors.payerEmail
    }), /*#__PURE__*/ React.createElement(Control, {
        onBlur: handleBlur,
        onChange: handleChange,
        as: "textarea",
        name: "message",
        label: text('message'),
        value: assignedPayment.message
    })));
};
export default AssignedPaymentForm;
